import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import PrimaryLink from "../../elements/primary-link";
import BodyText from "../../elements/body-text";
import classNames from "classnames";
// import Icon from "../../elements/icon";
import Textarea from "../../elements/textarea";
import PrimaryButton from "../../elements/primary-button";

import "./style.scss";

export default function ViewCaseSection({ heading, description, id, conversation, caseActive = false, status, caseClosed, formHeading, messageInput, attachFile, submitButton, disclaimer, thankYouMessage, updateSentSuccessFully, fileTypeNotValidText, fileSizeToBigErrorText, onCaseViewed }) {
  const inputFile = useRef(null);
  const [inputValue, setInputValue] = useState(undefined);
  const [Files, setFiles] = useState([]);
  const [FileArray, setFileArray] = useState([]);
  const [showForm, setshowForm] = useState(true);
  const [fileIndexesWithError, setFileIndexesWithErros] = useState([]);
  const [fileErrorMessages, setFileErrorMessages] = useState([]);
  const [uploadingFileIndexes, setUploadingFileIndexes] = useState([]);

  const supportedFileFormats = [".png", ".jpg", ".jpeg", ".gif", ".pdf"];

  const onLinkClick = () => {
    inputFile.current.click();
  };

  const statusClasses = classNames("case-status", {
    active: caseActive,
    closed: caseClosed
  });

  const formatBytes = (bytes, decimals) => {
    if (bytes === 0) {
      return "0 Byte";
    }
    var k = 1024; //Or 1 kilo = 1000
    var sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + " " + sizes[i];
  };

  const checkFileFormatIsValid = fileFormat => {
    return supportedFileFormats.filter(f => fileFormat.toLowerCase() === f).length;
  };

  const getInfo = evt => {
    const arrInputs = evt.target.files;

    for (var i = 0; i < arrInputs.length; i++) {
      var oInput = arrInputs[i];

      var files = [...Files];
      var sFileName = oInput.name;
      var fileInfo = {};
      if (sFileName.length > 0) {
        fileInfo.name = sFileName.substr(0, sFileName.lastIndexOf("."));
        fileInfo.size = formatBytes(oInput.size, 1);
        fileInfo.rawSize = oInput.size;
        fileInfo.type =
          "." +
          sFileName
            .split(".")
            .pop()
            .toUpperCase();

        const index = Files.length;
        setUploadingFileIndexes([...uploadingFileIndexes, index]);

        const fr = new FileReader();

        fr.readAsDataURL(oInput);
        // Handle progress, success, and errors
        // fr.onprogress = updateProgress;
        fr.onerror = errorHandler;
        fr.onloadend = e => doneUploading(e, oInput, index);
        // Here you can perform some operations on the data asynchronously
        fr.onprogress = e => setProgress(e, index);
      }

      files.push(fileInfo);
      setFiles(files);
    }
  };

  const setProgress = (e, i) => {
    // The target is the file reader
    // const fr = e.target;
    const loadingPercentage = (100 * e.loaded) / e.total;
    let node = document.getElementsByClassName("loader-indicator")[i];
    if (node) {
      node.style.width = `${loadingPercentage}%`;
    }
  };

  const doneUploading = (e, fileInfo, i) => {
    const fr = e.target;
    var result = fr.result;
    fileInfo.documentBody = result;

    setFileArray([...FileArray, fileInfo]);
    let node = document.getElementsByClassName("loader-indicator")[i];
    if (node) {
      node.style.width = `${0}%`;
    }
    setUploadingFileIndexes(uploadingFileIndexes.filter((file, j) => j !== i));
  };

  const errorHandler = (e, index, message) => {
    let node = document.getElementsByClassName("file-info")[index];
    node && node.classList.add("error");
    setFileIndexesWithErros([...fileIndexesWithError, index]);
    let errorMessages = [...fileErrorMessages];
    errorMessages[index] = message;
    setFileErrorMessages(errorMessages);
  };

  const onSubmit = evt => {
    evt.preventDefault();
    const formData = { message: inputValue, files: FileArray };
    submitButton.callback(evt, formData, id);
  };

  const deleteFile = i => {
    setFiles(Files.filter((item, j) => j !== i));
    setFileArray(FileArray.filter((item, j) => j !== i));
    setUploadingFileIndexes(uploadingFileIndexes.filter((file, j) => j === i));
    setFileIndexesWithErros(fileIndexesWithError.filter((file, j) => j === i));
    setFileErrorMessages([...fileErrorMessages.splice(0, i - 1), ...fileErrorMessages.splice(i + 1, fileErrorMessages.length)]);
  };

  useEffect(() => {
    if (onCaseViewed) onCaseViewed(id, status);
  }, []);

  useEffect(() => {
    if (!caseClosed) setshowForm(false);
  });

  useEffect(() => {
    if (Files.length) {
      if (Files[Files.length - 1].rawSize > 5 * 1024 * 1024) {
        errorHandler(null, Files.length - 1, fileSizeToBigErrorText.value);
      } else if (!checkFileFormatIsValid(Files[Files.length - 1].type)) {
        errorHandler(null, Files.length - 1, fileTypeNotValidText.value);
      }
    }
  }, [Files]);

  useEffect(() => {
    setshowForm(!updateSentSuccessFully);
  }, [updateSentSuccessFully]);

  return (
    <div className="view-case-section">
      <div className="view-case-section-heading">
        <Heading type={heading.type} html={heading.html} typographyClass={heading.typographyClass || "type-h3"} />
      </div>
      <BodyText className="case-id" html={id} />
      {description && <BodyText html={description} />}
      {conversation ? (
        conversation.map((item, index) => {
          return (
            <>
              {item.type === "message" && (
                <div className="case-message" key={index}>
                  <div className="message-head">
                    <span className="name">{item.name}</span>
                    <span className="time">{item.time}</span>
                  </div>
                  <BodyText html={item.body} />
                </div>
              )}

              {item.type === "reply" && (
                <div className="case-reply" key={index}>
                  <div className="reply-head">
                    <span className="name">{item.name}</span>
                    <span className="time">{item.time}</span>
                  </div>
                  <BodyText html={item.body} />
                </div>
              )}
              {item.type === "phone" && (
                <div className="case-call" key={index}>
                  <span className="name">
                    <span style={{ "margin-right": "10px", display: "inline-flex" }}>
                      {item.icon?.svg && (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item.icon.svg
                          }}
                        />
                      )}
                    </span>

                    {item.label}
                  </span>
                  <span className="time">{item.time}</span>
                </div>
              )}
            </>
          );
        })
      ) : (
        <></>
      )}
      {caseClosed && showForm ? (
        <>
          <div className={statusClasses}>{status}</div>
          <div className="form-heading">
            <Heading type={formHeading.type} html={formHeading.html} typographyClass={formHeading.typographyClass || "type-h4"} />
          </div>
          <form encType="multipart/form-data">
            <Textarea
              {...{
                ...messageInput,
                onChange: event => {
                  setInputValue(event.target.value.length ? event.target.value : undefined);
                },
                onFocus: event => {
                  setInputValue(undefined);
                },
                showError: messageInput.warningMessage && inputValue !== undefined && !inputValue.length
              }}
            />
            <div className="attach-file">
              <div className="file-label">{attachFile.label}</div>
              {Files &&
                Files.map((file, i) => {
                  return (
                    <>
                      <div className="file-info" key={file.name + i}>
                        <span className="loader-indicator" />
                        <span className="file-type">{file.type}</span>
                        <span className="file-name"> - {file.name}</span>
                        <span className="file-size">[{file.size}]</span>
                        <span className="file-remove" onClick={() => deleteFile(i)}>
                          &#10005;
                        </span>
                      </div>
                      {fileErrorMessages.length >= i && fileErrorMessages[i] != null && <span className="file-error">{fileErrorMessages[i]}</span>}
                    </>
                  );
                })}
              <PrimaryLink {...{ ...attachFile.link, callback: onLinkClick }} />
              <input type="file" id="file" ref={inputFile} size="10" multiple={false} accept=".jpg,.jpeg,.png,.gif,.pdf" style={{ display: "none" }} onChange={e => getInfo(e)} />
            </div>

            <div className="file-info-message">{attachFile.infoText}</div>
            {submitButton && (
              <PrimaryButton
                {...{
                  ...submitButton,
                  isDisabled: fileIndexesWithError.length > 0 || uploadingFileIndexes.length > 0 || !inputValue,
                  callback: evt => onSubmit(evt)
                }}
              />
            )}
          </form>
          {disclaimer && <BodyText html={disclaimer} className="disclaimer" />}
        </>
      ) : (
        !showForm &&
        thankYouMessage && (
          <div className="thank-you-note">
            <Heading type={thankYouMessage.heading.type} html={thankYouMessage.heading.html} typographyClass={thankYouMessage.heading.typographyClass || "type-h2"} />
            <BodyText {...thankYouMessage.body} />
          </div>
        )
      )}
    </div>
  );
}

ViewCaseSection.propTypes = {
  heading: PropTypes.shape({
    type: PropTypes.string,
    html: PropTypes.string,
    typographyClass: PropTypes.string
  }),
  id: PropTypes.string,
  body: PropTypes.shape({
    html: PropTypes.string,
    className: PropTypes.string
  }),
  conversation: PropTypes.arrayOf(
    PropTypes.shape({
      messgage: PropTypes.shape({
        body: PropTypes.object,
        time: PropTypes.string,
        name: PropTypes.string
      }),
      reply: PropTypes.shape({
        body: PropTypes.object,
        time: PropTypes.string,
        name: PropTypes.string
      }),
      phone: PropTypes.shape({
        time: PropTypes.string,
        label: PropTypes.string,
        icon: PropTypes.shape({ svg: PropTypes.string })
      })
    })
  ),
  caseActive: PropTypes.bool,
  status: PropTypes.string,
  caseClosed: PropTypes.bool,
  formHeading: PropTypes.object,
  messageInput: PropTypes.shape({
    value: PropTypes.string,
    pattern: PropTypes.string,
    label: PropTypes.string,
    warningMessage: PropTypes.string,
    infoMessage: PropTypes.string,
    showError: PropTypes.bool,
    onFocus: PropTypes.func,
    onChange: PropTypes.func
  }),
  attachFile: PropTypes.shape({
    label: PropTypes.string,
    infoText: PropTypes.string,
    link: PropTypes.shape({
      buttonText: PropTypes.string,
      callback: PropTypes.func,
      colorScheme: PropTypes.string,
      icon: PropTypes.shape({ svg: PropTypes.string })
    })
  }),
  submitButton: PropTypes.shape({
    callback: PropTypes.func,
    icon: PropTypes.shape({ svg: PropTypes.string }),
    colorScheme: PropTypes.string,
    isDisabled: PropTypes.bool,
    buttonText: PropTypes.string
  }),
  disclaimer: PropTypes.string,
  thankYouMessage: PropTypes.shape({
    heading: PropTypes.object,
    body: PropTypes.object
  })
};
